import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { productLinesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage/LazyImage";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Radio from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import styled, { css } from "styled-components";

const enum fields {
    heading = "heading",
    uploadFile = "uploadFile",
    fileTitle = "fileTitle",
    backgroundColor = "backgroundColor",
    padding = "padding",
    content = "content",
    checkboxFieldValue = "checkboxFieldValue",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.uploadFile]: string;
        [fields.fileTitle]: string;
        [fields.backgroundColor]: string;
        [fields.padding]: number;
        [fields.content]: string;
        [fields.checkboxFieldValue]: boolean;
    };
}
type Props = OwnProps;

export interface CommonCustomContainerStyles {
    messagesAccordionSection?: AccordionSectionPresentationProps;
    container?: InjectableCss;
    innerContainer?: InjectableCss;
    imageStyle?: InjectableCss;
    content?: InjectableCss;
    messagesGridContainer?: GridContainerProps;
    messagesAccordion?: AccordionPresentationProps;
    messageFilterGridItem?: GridItemProps;
}

export const CommonCustomContainerStyles: CommonCustomContainerStyles = {
    container: {
        css: css`
            padding: 0 0 20px 0;
            // margin: 10px;
        `,
    },
    messagesAccordion: {
        css: css`
            width: 100%;
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
            align-items: center;
            > div:first-child {
                margin: 0 10px 0 0;
            }
        `,
    },
    imageStyle: {
        css: css`
            width: 40px;
        `,
    },
    messagesGridContainer: { gap: 15 },
    messageFilterGridItem: { width: 12 },
    content: {
        css: css`
            display: flex;
        `,
    },
};

const styles = CommonCustomContainerStyles;

const uploadFileAndStaticContentCustom: React.FC<Props> = props => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomWrapper">
            <StyledWrapper {...styles.innerContainer}>
                {props.fields.checkboxFieldValue && (
                    <StyledWrapper>
                        <LazyImage {...styles.imageStyle} src="/UserFiles/Images/staticpages/cb-pdf-icon.png" />
                        {/* <LazyImage src="/UserFiles/Images/staticpages/cb-pdf.png" /> */}
                    </StyledWrapper>
                )}
                <StyledWrapper>
                    <a href={props.fields.uploadFile} target="blank">
                        {props.fields.fileTitle}
                    </a>
                </StyledWrapper>
                <StyledWrapper {...styles.content}>
                    <ContentWrapper backgroundColor={props.fields.backgroundColor} padding={props.fields.padding}>
                        {parse(props.fields.content || "", parserOptions)}
                    </ContentWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};
const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.checkboxFieldValue,
            displayName: "PDF Icon",
            editorTemplate: "CheckboxField",
            defaultValue: false,
            fieldType: "General",
        },
        {
            name: fields.uploadFile,
            displayName: "Upload File",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            // placeholder: "text placeholder",
        },
        {
            name: fields.fileTitle,
            displayName: "File Title",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "Enter file title",
        },
        {
            fieldType: "General",
            name: fields.backgroundColor,
            editorTemplate: "ColorPickerField",
            displayName: "Background Color",
            defaultValue: "",
        },
        {
            fieldType: "General",
            name: fields.padding,
            editorTemplate: "IntegerField",
            displayName: "Content Padding",
            defaultValue: 0,
        },
        {
            name: fields.content,
            displayName: "Content",
            editorTemplate: "RichTextField",
            defaultValue: "",
            fieldType: "Contextual",
            extendedConfig: { height: 170 },
            // expandedToolbarButtons: {
            //     moreMisc: {},
            //     code: {},
            // },
        },
    ],
};

const widgetModule: WidgetModule = {
    component: uploadFileAndStaticContentCustom,
    definition,
};

export default widgetModule;

const Style = styled.div`
    padding: 15px;
`;

const ContentWrapper = styled.div<{ backgroundColor: string; padding: number }>`
    ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor};` : null)};
    ${({ padding }) => (padding ? `padding: ${padding}px;` : null)};
    & > *:first-child {
        margin: 0;
    }
`;
